module.exports = __webpack_public_path__ + "static/media/Slide56.17312b28.JPG";